export enum VideoStatus {
    Unknown,
    EventOnly,
    UploadRequested,
    Uploading,
    Uploaded,
    Error,
    UserUploadRequested,
    Downloaded,
    Cancelled,
    NoFootageAvailable,
    Archived,
    NoFilesAvailable,
    Restricted,
    PartiallyDownloaded,
    Expired,
    HardwareDeleted,
    PartiallyUploaded,
    MediaDeleted,
    MediaPendingDeletion,
    AwaitingIndexing,
    AwaitingRedaction,
    RedactionCompleted,
    IndexingInProgress,
    RedactionInProgress,
    AwaitingVideoMute
}
